import { Button, Icon, Modal } from '@scuf/common';
import i18next from 'i18next';

interface IAlertModal {
  onClose: () => void;
  message: string;
}
export const AlertModal = (props: IAlertModal) => {
  return (
    <Modal
      size="small"
      onClose={props.onClose}
      open={true}
      closeOnDocumentClick={false}
      className="unlink-modal"
    >
      <Modal.Content>
        <Icon
          name="badge-warning"
          className={`status-icon`}
          root="common"
          size="medium"
        />
        <div className="desc">{props.message}</div>
      </Modal.Content>
      <Modal.Footer>
        <Button
          type="primary"
          size="small"
          content={i18next.t('Close')}
          onClick={props.onClose}
        />
      </Modal.Footer>
    </Modal>
  );
};
